
const Footer = () => {
    
    return (
        <footer className="bg-detail text-white">
            <div className="container">
            <p><small>© Copyright <a href="http:github.com/lulemoses67">Moses Lule</a></small></p>
            </div>
        </footer>
    );
}
export default Footer;